import { createSelector } from 'reselect';
const selectEditor = state => state.editor;

export const selectEditorIsActive = createSelector(
  selectEditor,
  ({ cta_flow, thumbnail_flow, custom_access_flow, video_settings_flow }) =>
    cta_flow || thumbnail_flow || custom_access_flow || video_settings_flow
);
